import { Config } from "./../Routes/Config";
import ApiService from "./config";

export const Login_service = (body: any) => {
    return ApiService.post("admin/login", body);
};

// -------------------------Clients------------------------

export const Get_dashboard = (body: any) =>
    ApiService.post("admin/getDashboard", body);
export const Get_Clients = () => ApiService.get("admin/clients/getClients");

export const add_Clients = (body: any) =>
    ApiService.post("admin/clients/addClient", body);

export const update_Clients = (clientId: number, body: any) =>
    ApiService.put(`admin/clients/updateClient/${clientId}`, body);

export const delete_Clients = (clientId: number) =>
    ApiService.delete(`admin/clients/deleteClient/${clientId}`);

// -------------------------Banners------------------------

export const Get_Banners = () => ApiService.get(`admin/getAllBanners`);

export const add_Banners = (body: any) =>
    ApiService.post(`admin/addBanner`, body);

export const update_Banners = (id: any, body: any) =>
    ApiService.put(`admin/updateBanner/${id}`, body);

export const Delete_Banner = (id: any) =>
    ApiService.delete(`admin/deleteBanner/${id}`);

// -----------------explore --------------------
export const Get_explore = () => ApiService.get(`admin/getAllExplores`);

export const add_explore = (body: any) =>
    ApiService.post(`admin/addExplore`, body);

export const update_explore = (id: any, body: any) =>
    ApiService.put(`admin/updateExplore/${id}`, body);

export const Delete_explore = (id: any) =>
    ApiService.delete(`admin/deleteExplore/${id}`);

// -------------------------Exclusives------------------------

export const Get_Exclusive = () => ApiService.get(`admin/getAllExclusives`);

export const add_Exclusive = (body: any) =>
    ApiService.post(`admin/addExclusive`, body);

export const update_Exclusive = (id: any, body: any) =>
    ApiService.put(`admin/updateExclusive/${id}`, body);

export const Delete_Exclusive = (id: any) =>
    ApiService.delete(`admin/deleteExclusive/${id}`);

// -------------------------Category------------------------

export const Get_category = () => ApiService.get(`admin/getAllCategories`);
export const Get_category_campaigns = () =>
    ApiService.get(`admin/getCampaignCategories`);

export const add_Category = (body: any) =>
    ApiService.post(`admin/addCategory`, body);

export const update_Category = (id: any, body: any) =>
    ApiService.put(`admin/updateCategory/${id}`, body);

export const Delete_category = (id: any) =>
    ApiService.delete(`admin/deleteCategory/${id}`);

// -------------------------campaigns------------------------

export const Get_campaigns = (page: any) =>
    ApiService.get(`admin/getAllCampaigns?page=${page}`);

export const add_campaigns = (body: any) =>
    ApiService.post(`admin/addCampaign`, body);

export const update_campaigns = (id: any, body: any) =>
    ApiService.put(`admin/updateCampaign/${id}`, body);

export const Delete_campaigns = (id: any) =>
    ApiService.delete(`admin/deleteCampaign/${id}`);

export const End_campaigns = (body: any) =>
    ApiService.post(`admin/endCampaign`, body);

// -------------------------giveaway products------------------------

export const Get_giveawayproducts = (page: any) =>
    ApiService.get(`admin/getAllGiveaways?page=${page}`);

export const add_giveawayproducts = (body: any) =>
    ApiService.post(`admin/addGiveaway`, body);

export const update_giveawayproducts = (id: any, body: any) =>
    ApiService.put(`admin/updateGiveaway/${id}`, body);

export const Delete_giveawayproducts = (id: any) =>
    ApiService.delete(`admin/deleteGiveaway/${id}`);

// -------------------------PromoCodes------------------------

export const Get_Promocode = () => ApiService.get(`admin/getAllPromoCodes`);

export const add_Promocode = (body: any) =>
    ApiService.post(`admin/addPromocode`, body);

export const update_Promocode = (id: any, body: any) =>
    ApiService.put(`admin/updatePromocode/${id}`, body);

export const Delete_Promocode = (id: any) =>
    ApiService.delete(`admin/deletePromocode/${id}`);

// -------------------------Products------------------------

export const Get_Products = (page: any) =>
    ApiService.get(`admin/getAllProducts?page=${page}`);

export const add_Products = (body: any) =>
    ApiService.post(`admin/addProduct`, body);

export const update_Products = (id: any, body: any) =>
    ApiService.put(`admin/updateProduct/${id}`, body);

export const Delete_Products = (id: any) =>
    ApiService.delete(`admin/deleteProduct/${id}`);

//-----------USERS------------------------

export const get_Users = () => ApiService.get(`admin/getAllUsers`);

//----------------------Orders---------------------

export const get_Orders = (status: any, page: any, campaign_id: any) =>
    campaign_id
        ? ApiService.get(
              `admin/getOrders/${status}?page=${page}&&campaign_id=${campaign_id}`
          )
        : ApiService.get(`admin/getOrders/${status}?page=${page}`);

export const getOrderDetails = (id: number) =>
    ApiService.get(`admin/getOrder/${id}`);

export const UpdaterOrderApi = (body: any) =>
    ApiService.put(`admin/updateOrder`, body);

export const searchOrder = (body: any) =>
    ApiService.post(`admin/searchOrder`, body);

// --------------------Lucky Draw----------------

export const GetLuckyDraw = (status: number) =>
    ApiService.get(`admin/pendingDraws/${status}`);

export const updateLuckyDraw = (body: any) =>
    ApiService.patch(`admin/updateDrawDetails`, body);

export const CampaignDetails = (campaign_id: any, page: any) =>
    ApiService.get(`admin/getCampaignUsersList/${campaign_id}?page=${page}`);
export const CampaignDetailsExport = (campaign_id: any) =>
    ApiService.get(`admin/exportUsersList/${campaign_id}`);

export const UpdateOrderStatus = (body: any) =>
    ApiService.patch(`admin/updateOrderStatus`, body);

//---------------------------Get Config------------------------

export const getAllConfig = () => ApiService.get(`admin/getConfig`);

export const updateConfig = (body: any) =>
    ApiService.patch(`admin/updateConfig`, body);

// -----------------Notifications --------------------------

export const SendNotifications = (body: any) =>
    ApiService.post(`admin/sendNotifications`, body);

export const getUsers = (page: any) =>
    ApiService.get(`admin/getAllUsers?page=${page}`);

// ---------------------------Search Product By Camaign------
export const searchCampaignByProduct = (body: any) =>
    ApiService.post(`admin/searchCampaign`, body);

export const searchProduct = (body: any) =>
    ApiService.post(`admin/searchProduct`, body);

export const GetCampaignCodes = () => ApiService.get("admin/getCampaignCodes");

export const searchGiveawayProducts = (body: any) =>
    ApiService.post("admin/searchGivaway", body);

// -----------------upload images============

export const uploadImage = (body: any) =>
    ApiService.post("admin/uploadSingle", body);

export const uploadMutipleImage = (body: any) =>
    ApiService.post("admin/uploadMultipleImges", body);

export const getPorductDetailsSku = (body: any) =>
    ApiService.post("admin/getProduct", body);
